import React, { memo, useCallback } from "react";
import { Button } from "@chakra-ui/react";
import { IS_APPLE } from "modules/utils/Constants";
import colors from "app/colors";
import { BoldIcon } from "modules/icons";
import { IQuillFormats } from "modules/quill/use-quill";

interface IProps {
  format: (name: string, value: any) => void;
  activeFormats: IQuillFormats;
}

const ComposeQuillBold = ({ format, activeFormats }: IProps) => {
  const isSelected = !!activeFormats.bold;

  const onMouseDown = useCallback(
    (e: React.MouseEvent) => {
      e.preventDefault();
      if (format) {
        format("bold", !isSelected);
      }
    },
    [isSelected, format],
  );

  const bg = isSelected ? colors.gray0 : colors.transparent;

  return (
    <Button
      variant="hover"
      size="xs"
      aria-label="Format text as bold"
      title={IS_APPLE ? "Bold (⌘B)" : "Bold (Ctrl+B)"}
      tabIndex={-1}
      onMouseDown={onMouseDown}
      px={0}
    >
      <BoldIcon boxSize={5} fill={colors.gray40} bg={bg} borderRadius={4} />
    </Button>
  );
};

export default memo(ComposeQuillBold);
